<template>
    <div class="CustomArticle">
        <el-dialog title="文章详情" :visible.sync="articleDialog" width="1000px" append-to-body>
            <div class="article" v-loading="loading">
                <div class="title">{{ article.title }}</div>
                <div class="footer">
                    <span><i class="el-icon-view"></i> {{ article.readCount }} 阅读量</span>
                    <span style="cursor: pointer"><i class="fa" :class="{
                        'fa-thumbs-o-up': !article.isLike,
                        'fa-thumbs-up': article.isLike,
                    }"></i>
                        {{ article.likeCount }} 点赞数</span>
                </div>
                <div class="imgs" v-if="article.imgs && article.imgs.length">
                    <el-carousel height="360px" :autoplay="false">
                        <el-carousel-item v-for="(item, index) in article.imgs" :key="index">
                            <div class="box">
                                <img :src="item" alt="" />
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="content" v-html="article.content"></div>
                <div class="describe">
                    <p>本文分类： {{ article.catName }}</p>
                    <p>
                        本文标签：<el-tag v-for="(tag, i) in article.tags" :key="i">{{ tag }}
                        </el-tag>
                    </p>
                    <p>文章描述： {{ article.descString }}</p>
                    <p>发布日期： {{ article.createTime }}</p>
                    <div><span style="float: left;">作者信息：</span>
                        <div class="logo"><img v-if="user.img" :src="user.img" alt="" /></div>
                        <i v-if="!user.img" style="font-size: 20px;" class="fa fa-user-circle-o"></i>
                        <span style="font-size: 18px;font-weight: 700;line-height: 21px;margin: 0 10px;">{{ user.name }}
                        </span>
                        <span style="line-height: 40px;">{{ user.title }}</span>
                        <span v-if="user.unitName">{{ user.unitName }}</span>
                    </div>
                </div>
            </div>

            <div class="btns">
                <el-button type="primary" @click="articleDialog = false">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment"
export default {
    data() {
        return {
            loading: false,
            article: {},
            articleDialog: false,
            user: {}
        }
    },
    methods: {
        showDialog(id) {
            this.articleDialog = true
            this.init(id)
        },
        init(id) {
            this.loading = true;
            this.$https.get(this.$api.ContentManagement.articleDetail + id).then(res => {
                this.article = Object.assign(res, {
                    imgs: res.imgs
                        ? res.imgs.map((item) => this.$api.imgBaseUrl + item)
                        : [],
                    createTime: moment(res.createTime).format("yyyy-MM-DD HH:mm:ss"),
                    url: window.location.origin + "/#/article?id=" + res.id,
                });
                this.loading = false;
                this.articleDialog = true;
                this.initUser()
            })
        },
        initUser() {
            const user = JSON.parse(JSON.stringify(this.article))
            let userInfo = {
                name: "广西公路学会",
                url: require("@/assets/logo.png"),
                title: "官方平台",
                type: "ACCOUNT",
            }
            switch (user.type) {
                case "MEMBER":
                    if (user.member) {
                        userInfo = {
                            id: user.member.id,
                            name: user.member.name + (user.member.expert ? " (专家)" : ""),
                            img: user.member.icon ? this.$api.imgBaseUrl + user.member.icon : "",
                            title: (user.unit ? "单位个人会员" : "个人会员" + (user.member.pre ? ' (预备)' : '')),
                            unitId: user.unit && user.unit.id,
                            type: "MEMBER",
                            unitName: user.unit && user.unit.name + (user.unit.pre ? ' (预备会员)' : ''),
                        }
                    }
                    break;
                case "UNIT":
                    if (user.unit) {
                        userInfo = {
                            name: user.unit.name,
                            img: "",
                            type: "UNIT",
                            title: "单位会员" + (user.unit.pre ? ' (预备)' : ''),
                            id: user.unit.id,
                        }
                    }
                    break;
            }
            this.user = Object.assign({}, userInfo)
        },
    }
}
</script>


<style lang="scss" scoped>
.CustomArticle {
    position: relative;
}

.article {
    position: relative;
    color: #999;

    .title {
        color: #333;
        font-size: 18px;
        font-weight: bold;
        line-height: 40px;
    }

    .imgs {
        position: relative;
        width: 100%;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .content {
        text-indent: 2;
        color: #333;
        line-height: 30px;
        padding: 10px 0;
        border-bottom: 1px solid #dedede;
    }

    .footer {
        padding: 10px 0;
        border-bottom: 1px solid #dedede;

        span {
            margin-right: 20px;
        }
    }

    .describe {
        padding: 10px 0;
        color: #666;
        line-height: 30px;

        .el-tag {
            margin-right: 10px;
            margin-bottom: 10px;
            cursor: pointer;
        }

        .logo {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: inline-block;
            overflow: hidden;
            float: left;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}

.btns {
    text-align: center;
}

/deep/.el-dialog__body {
    padding-top: 0;
}

/deep/.el-dialog__header {
    // display: none;
}
</style>